import React from 'react';

import Flex from '@ui/Flex';

import classes from './style.module.scss';

const Hint = () => (
  <Flex gap="xs" layout="col">
    <div>
      <strong>Drag</strong>
      <span className={classes.BlockMenu_TooltipText}> to move</span>
    </div>
    <div>
      <strong>Click</strong>
      <span className={classes.BlockMenu_TooltipText}> to open menu</span>
    </div>
  </Flex>
);

export default React.memo(Hint);
